import React, { Component } from 'react'

export class Tickbox extends Component {
  render() {
    return (
        <div className="m-tickBox">
        <img className="m-tick" src={require("../../assets/imgs/tick.png")} alt="tickbox" />
        <span className="m-tickBoxText">
            {this.props.text}
        </span>
      </div>
    )
  }
}

export default Tickbox
